/**
 * 출고지 관리
 *
 * --
 *
 */

import React, { useState, useEffect } from 'react';
import ForwardingLocationPresenter from './ForwardingLocationPresenter';
import MessageAlert from 'utils';
import { ForwardingLocationApi } from 'api';

/**----------------------------------------
 * [Component] 출고지관리: 컨테이너
 * ----------------------------------------
 */
const ForwardingLocationContainer = ({ shopId, defaultShopId, permission }) => {
  /* ===== INIT ===== */
  /* ===== STATE ===== */
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(null);
  const [currentShop, setCurrentShop] = useState(defaultShopId ?? null);
  const [forwardingLocationList, setForwardingLocationList] = useState([]);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */

  /**--------------------
   * 출고지 목록 조회
   * --------------------
   */
  const getLocationList = async () => {
    setLoading(true);
    try {
      const { status, message, data } =
        await ForwardingLocationApi.getForwardingLocations({
          shop_information_id: currentShop,
        });
      if (status !== 200) throw { message };

      setTimeout(() => {
        setForwardingLocationList(data);
        setLoading(false);
      }, 500);
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  /*  */
  useEffect(() => {
    currentShop && getLocationList();
  }, [currentShop]);

  useEffect(() => {
    if (defaultShopId) {
      setCurrentShop(defaultShopId);
    }
  }, [defaultShopId]);

  /* ===== RENDER ===== */
  return (
    <ForwardingLocationPresenter
      {...{
        loading,
        // onChange,
        forwardingLocationList,
        setForwardingLocationList,
        permission,
        currentShop,
        setCurrentShop,
        modal,
        setModal,
        getLocationList,
      }}
    />
  );
};

ForwardingLocationContainer.defaultProps = {
  shopId: null,
  defaultShopId: null,
  permission: 'ADMIN',
};
export default ForwardingLocationContainer;
